// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3sXjy","questions":"styles_questions__4_PyR","footer":"styles_footer__2ncUQ"};